<script setup>
import {addWeeks, format, parse} from "date-fns";
import {ref} from "vue";

const {courses, holidays} = defineProps(['courses', 'holidays']);

const all_courses = ref( Object.values( courses ) );

all_courses.value.map( course => {
    const dates = [];

    if ( course.course_type === 'dance' ) {
        const date = parse( course.scheduled_date, 'yyyy-MM-dd HH:mm', new Date );

        let day_date = null,
            nbr_courses = 0,
            i = 0;

        while ( nbr_courses < 3 ) {
            day_date = format( addWeeks( date, i ), 'yyyy-MM-dd' );
            i++;

            if ( ! holidays.includes( day_date ) ) {
                nbr_courses++;
                dates.push( day_date );
            }
        }
    } else {
        const date = parse( course.scheduled_date, 'yyyy-MM-dd HH:mm', new Date );
        dates.push( date );
    }

    course.dates = dates;

    return course;
} );
</script>

<template>
    <div class="border rounded-3xl p-5 sm:p-10 lg:sticky lg:top-10">
        <h3 class="text-white text-xl font-bold mb-5">Résumé des cours</h3>

        <div class="flex flex-col flex-nowrap gap-2 mb-5">
            <div v-for="(course, index) in all_courses.filter( item => item )" :key="index"
                 class="w-full text-white text-center px-2 py-2 transition-colors" :class="{
                            'bg-dance': course.course_type === 'dance',
                            'bg-fitness': course.course_type === 'fitness',
                         }">
                <p class="font-bold uppercase mb-1">{{ course.title }}</p>
                <span class="text-xs border-b block pb-1 mb-1">{{ course.schedule_start }} - {{ course.schedule_end }}</span>
                <span class="text-sm block py-1" v-for="date in course.dates">{{ format( date, 'eeee dd LLLL' ) }}</span>
            </div>
        </div>

        <p class="text-white text-lg">
            <span class="block" v-if="Object.values( courses ).filter( course => course.course_type === 'dance' ).length > 0">Cours de danse : <span class="strong">{{ Object.values( courses ).filter( course => course.course_type === 'dance' ).length * 30 }} €</span> pour 3 semaines d'essai</span>
            <span class="block" v-if="Object.values( courses ).filter( course => course.course_type === 'fitness' ).length > 0">Cours de fitness : <span class="strong">{{ Object.values( courses ).filter( course => course.course_type === 'fitness' ).length * 10 }} €</span> pour 1 semaine d'essai</span>
        </p>
    </div>
</template>